import { Component, OnInit } from '@angular/core';
import { Router } from '@angular/router';
import { Observable } from 'rxjs/Rx';
import 'rxjs/add/operator/catch';
import { NotificationService } from '../../../api/notification/notification.service';
import { NotificationModel } from '../../../api/notification/noti';
import { ApplicationService } from '../../../api/application/application.service';
import { ComboApplication } from '../../../api/application/comboapplication';
import { ReplaceDataService } from 'api/replacedata/replacedata.service';

import { CountryGroupService } from '../../../api/countrygroup/countrygroup.service';
import { CountryModel } from '../../../api/country/country';

declare var $: any;
declare var jQuery: any;
@Component({
    selector: 'notification-page',
    templateUrl: './notification.html'
})
export class NotificationComponent implements OnInit {
    cmbBindCountry: CountryModel[];
    countryList: CountryModel[];
    cmbCountry: CountryModel[];

    notificationList: NotificationModel[];
    notification: NotificationModel;
    applicationList: ComboApplication[];
    selectApplication: string;
    selectdevicetype: string;
    msg = "";
    message: string;
    id: string;
    i: number;
    progressPer :string = "0%";

    pushtitle : string = "";
    pushmessage : string = "";
    selectPushApplicationId : string = "";
    selectPushDeviceType : string = "";
    selectPushPurchaseType :string = "ALL";
    selectPushLastActiveUser : string = "1";

    constructor(private countrygroupservice: CountryGroupService,private notificationService: NotificationService, private applicationService: ApplicationService,
        private router: Router, private ReplaceDataService: ReplaceDataService) {
    }
    ngOnInit() {
        if (localStorage.getItem('id_token') && (localStorage.getItem('type') == 'SUPERADMIN' || localStorage.getItem('type') == 'ADMIN')) {
            this.progressPer = "0%";
            this.selectPushPurchaseType = "ALL";
            this.selectPushLastActiveUser = "1";
            this.countrygroupservice
            .allCountryList()
            .then(data => {
                this.progressPer = "15%";
                 this.cmbCountry = data
                this.initNotificationList();
            });
        } else {
            this.router.navigate(['/']);
        }
    }
    initNotificationList() {
        this.applicationService
            .ComboApplication()
            .then(data => {
                this.progressPer = "35%";
                this.applicationList = data;
                this.selectApplication = this.applicationList[0].id;
                this.selectdevicetype = "iOS";

                this.selectPushApplicationId = this.applicationList[0].id;
                this.selectPushDeviceType = "iOS";
            }).then(dttt => {
                this.getNotification();
            })
    }
    getNotification() {
        var jData = {
            applicationId: this.selectApplication,
            type: this.selectdevicetype,
        }
        this.notificationService
            .allNotification(jData)
            .then(
                data => {
                    this.progressPer = "100%";
                    this.notificationList = data;
                    this.progressTimeOut();
                }
            );
    }
    progressTimeOut()
    {
      setTimeout(()=>
      { 
        this.progressPer = "0%"; 
      },200);
    }
    cancelAction() {
        this.msg = "";
    }
    onChange(countryGroupValue) {
        this.selectApplication = countryGroupValue;
        this.getNotification();
    }
    onDeviceTypeChange(deviceValue) {
        this.selectdevicetype = deviceValue;
        this.getNotification();
    }
    submitNotification() {
        if (this.msg == "") {
            $.notify({
                message: "Please Enter Notification Message."
            }, {
                type: 'danger',
                placement: {
                    from: 'bottom',
                    align: 'left'
                },
                delay: 100,
                timer: 100
            });
        }
        else {
            var iNotification = {
                applicationId: this.selectApplication,
                message: this.msg,
                type: this.selectdevicetype
            }
            this.notificationService.inNotification(iNotification)
                .then(data => {
                    this.getNotification();
                    $(function () {
                        $('#addnotificationModel').modal('toggle');
                    });
                    this.cancelAction();
                });
        }
    }
    deleteNotification(i, notifi) {
        this.i = i;
        this.notification = notifi;
        $(function () {
            $('#deleteSureModal').modal('toggle');
        });
    }
    deleteSureNotification() {
        this.notificationService
            .deleteNotification(this.notification.id)
            .then(data => {
                if (data.status == true) {
                    this.notificationList.splice(this.i, 1)
                    $.notify({
                        message: data.message
                    }, {
                        type: 'success',
                        placement: {
                            from: 'bottom',
                            align: 'left'
                        },
                        delay: 100,
                        timer: 100
                    });
                } else {
                    $.notify({
                        message: data.message
                    }, {
                        type: 'danger',
                        placement: {
                            from: 'bottom',
                            align: 'left'
                        },
                        delay: 100,
                        timer: 100
                    });
                }
            });
        $(function () {
            $('#deleteSureModal').modal('toggle');
        });
        this.cancelAction();
    }

    showPushNotification()
    {
        this.selectPushApplicationId = this.applicationList[0].id;
        this.selectPushDeviceType = "iOS";
        this.selectPushPurchaseType = "ALL";
        this.selectPushLastActiveUser = "1";
        this.cancelPushAction();
        $("#country option:selected").prop("selected", false);
        this.cmbBindCountry = this.cmbCountry;
        $(function () {
            $('#country').select2({
                dropdownParent: $('#pushnotificationModel'),
                placeholder: 'Select Country'
            });
        })
    }

    submitPushNotification()
    {
        var countrycodes = $('#country').val();
        if (this.selectPushApplicationId == "") {
            $.notify({
                message: "Please Select Application."
            }, {
                type: 'danger',
                placement: {
                    from: 'bottom',
                    align: 'left'
                },
                delay: 100,
                timer: 100
            });
            return;
        }
        if (this.selectPushDeviceType == "") {
            $.notify({
                message: "Please Select Device Type."
            }, {
                type: 'danger',
                placement: {
                    from: 'bottom',
                    align: 'left'
                },
                delay: 100,
                timer: 100
            });
            return;
        }
        if (countrycodes == undefined || countrycodes == "") {
            countrycodes = "";
            // $.notify({
            //     message: "Please Select Atleast One Country."
            // }, {
            //     type: 'danger',
            //     placement: {
            //         from: 'bottom',
            //         align: 'left'
            //     },
            //     delay: 100,
            //     timer: 100
            // });
            // return;
        }
        if (this.selectPushPurchaseType == "") {
            $.notify({
                message: "Please Select Purchase Type."
            }, {
                type: 'danger',
                placement: {
                    from: 'bottom',
                    align: 'left'
                },
                delay: 100,
                timer: 100
            });
            return;
        }
        if (this.selectPushLastActiveUser == "") {
            $.notify({
                message: "Please Select Last Active Days."
            }, {
                type: 'danger',
                placement: {
                    from: 'bottom',
                    align: 'left'
                },
                delay: 100,
                timer: 100
            });
            return;
        }
        if (this.pushtitle == "") {
            $.notify({
                message: "Please Enter Title."
            }, {
                type: 'danger',
                placement: {
                    from: 'bottom',
                    align: 'left'
                },
                delay: 100,
                timer: 100
            });
            return;
        }
        if (this.pushmessage == "") {
            $.notify({
                message: "Please Enter Message."
            }, {
                type: 'danger',
                placement: {
                    from: 'bottom',
                    align: 'left'
                },
                delay: 100,
                timer: 100
            });
            return;
        }
        var pNotification = {
            applicationId: this.selectPushApplicationId,
            devicetype : this.selectPushDeviceType,
            purchase : this.selectPushPurchaseType,
            lastactivedays : this.selectPushLastActiveUser,
            countrycode : countrycodes,
            title : this.pushtitle,
            message: this.pushmessage
        }
        this.notificationService.pushNotification(pNotification)
            .then(data => {
                if(data.status)
                {
                    $(function () {
                        $('#pushnotificationModel').modal('toggle');
                    });
                    $.notify({
                        message: "Notification Successfully Sent"
                    }, {
                        type: 'success',
                        placement: {
                            from: 'bottom',
                            align: 'left'
                        },
                        delay: 100,
                        timer: 100
                    });
                }
                else
                {
                    $.notify({
                        message: data.message
                    }, {
                        type: 'danger',
                        placement: {
                            from: 'bottom',
                            align: 'left'
                        },
                        delay: 100,
                        timer: 100
                    });
                }
            });
    }

    onPushApplicationChange(appId)
    {
        this.selectPushApplicationId = appId;
    }
    onPushDeviceTypeChange(devicetype)
    {
        this.selectPushDeviceType = devicetype;
    }
    onPushLastActiveUserChange(lastactive)
    {
        this.selectPushLastActiveUser = lastactive;
    }
    onPushPurchaseTypeChange(type)
    {
        this.selectPushPurchaseType = type;
    }
    cancelPushAction() {
        this.pushtitle = "";
        this.pushmessage = "";
    }
}


// WEBPACK FOOTER //
// F:/SVNNew/Web/Phoenix HealthCare/HealthCare_UI/src/app/structure/notification/notification.page.ts